import { FC } from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import Column from '../../../Pdf/components/Column';
import theme from '../../../Pdf/components/theme';
import FundOverviewDataPoint from './FundOverviewDatapoint';
import { PeriodEndReportFundOverviewDataPoint } from '../../types';

const styles = StyleSheet.create({
  container: {
    width: '400px',
    paddingRight: theme.spacing(theme.spacingSizes.lg),
    borderWidth: 0.75,
    borderColor: theme.palette.grey[300],
    borderStyle: 'solid',
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
  },
  containerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    width: '100%',
  },
  leftGutter: {
    width: theme.spacing(theme.spacingSizes.lg),
    backgroundColor: theme.palette.grey[50],
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  },
  tableBody: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
});

type Props = {
  dataPoints: Array<PeriodEndReportFundOverviewDataPoint>;
};

const PeriodEndReportDataPointsTable: FC<Props> = ({ dataPoints }) => {
  return (
    <Column centered>
      <View style={styles.container}>
        <View style={styles.containerInner}>
          <View style={styles.leftGutter} />
          <View style={styles.tableBody}>
            {dataPoints.map((dataPoint, index) => (
              <FundOverviewDataPoint
                key={dataPoint.label}
                dataPoint={dataPoint}
                index={index}
                totalCount={dataPoints.length}
              />
            ))}
          </View>
        </View>
      </View>
    </Column>
  );
};

export default PeriodEndReportDataPointsTable;
